<template>
  <div class="material-list">
    <div class="header">
      <div class="top">
        <span class="title">邮寄资料清单</span>
        <router-link class="link" target="_blank" :to="goProduct(order)">查看资料详情</router-link>
      </div>
      <div class="bottom">
        带
        <span class="required"> * </span>为必备资料
      </div>
    </div>
    <div class="content">
      <ul>
        <li class="material-of-identity" v-for="(identityMaterial, index) in identityMaterials" :key="index">
          <template v-if="identityMaterial.materials.length > 0">
            <div class="left-name">
              <div class="left-line"></div>
              <div class="idenity-name" v-text="identityMaterial.identity"></div>
            </div>
            <div class="right-content" :class="{'bottom-line': index+1 !== identityMaterials.length}">
              <div class="applicant-names">
                <span v-for="(applicant, i) in identityMaterial.applicants" :key="i">
                  <span v-text="applicant.applicant_name"></span>
                  <span v-if="i != identityMaterial.applicants.length - 1">、</span>
                </span>
              </div>

              <ul>
                <li class="material" v-for="(material, k) in identityMaterial.materials" :key="k"
                  :class="{'border-bottom': k+1 !== identityMaterial.materials.length}">
                  <div class="title">
                    <span v-text="material.name"></span>
                    <span class="required" v-if="material.required">*</span>
                  </div>

                  <div class="action">
                    <a @click="showImage(material.sample)" class="el-button s-btn" v-if="material.sample && material.sample.length > 0">查看样例</a>
                    <a :href="material.template" class="el-button s-btn is-plain" v-if="material.template">下载模板</a>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </li>
      </ul>
    </div>
    <div class="footer mail-list-footer" v-if="showEnsure">
      <el-checkbox v-model="materialEnsure" @change="changeEnsure">确认以上资料已备齐</el-checkbox>
    </div>

    <!-- 多图预览弹窗 -->
    <multi-image-preview v-model="multiImagePreviewOpen" :multiImageArray="multiImageArray"></multi-image-preview>
  </div>
</template>

<script>
import SFService from '../../services/sf-service';
import multiImagePreview from '../../components/common/multi-image-preview';
import sensorService from '../../services/sensor-service';

export default {
  name: 'orderMailList',
  components: {
    multiImagePreview,
  },
  props: ['order', 'showEnsure'],
  data() {
    return {
      identityMaterials: [],
      materialEnsure: false,
      multiImagePreviewOpen: false,
      multiImageArray: [],
    };
  },
  methods: {
    changeEnsure(event) {
      this.$emit('ensureChanged', event.target.checked);
    },

    // 打开多图预览弹窗
    showImage(data) {
      this.multiImagePreviewOpen = true;

      // 后端部分接口资料样例 sample 返回的仍然是字符串，而不是数组，这里先做一个兼容处理。
      if (typeof data === 'string') {
        const buildData = [];
        buildData.push(data);
        this.multiImageArray = buildData;
      } else {
        this.multiImageArray = data;
      }
    },
    // 获取路由跳转地址
    goProduct(order) {
      // 商详神策埋点page_from字段
      const pageFrom = sensorService.getPageFrom('订单页');
      return { name: 'product', params: { visa_product_id: order.visa_product_id }, query: { from: 'sf_order_mail_list', ...pageFrom } };
    },
  },
  created() {
    this.identityMaterials = SFService.classfiyMaterials(this.order);
  },
  watch: {
    order(newVal) {
      if (newVal.user_order_id) {
        this.identityMaterials = SFService.classfiyMaterials(this.order);
      }
    },
  },
};
</script>

<style lang="less">
.mail-list-footer {
  .el-checkbox {
    .el-checkbox__label {
      color: #5e9be1;
    }
  }
}
</style>

<style lang="less" scoped>
.material-list {
  margin-top: 0;
  .header {
    background-color: #fbfbfb;
    padding: 14px 30px 14px 20px;
    .top {
      margin-bottom: 10px;
      .title {
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
      }
      .link {
        float: right;
        color: #5e9be1;
        font-size: 14px;
        margin-top: 3px;
      }
    }
    .bottom {
      color: #777;
      font-size: 12px;
      .required {
        color: #ff5a60;
      }
    }
  }
  .content {
    padding: 0 30px 0 40px;
    background-color: #fff;
    ul {
      list-style: none;
      .material-of-identity {
        padding-top: 14px;
        font-size: 0;
        .left-name {
          float: left;
          width: 87px;
          font-size: 0;
          line-height: 26px;
          .left-line {
            width: 2px;
            height: 16px;
            background-color: #00a0e9;
            border-radius: 1px;
            margin-right: 5px;
            display: inline-block;
            vertical-align: middle;
          }
          .idenity-name {
            font-size: 14px;
            font-weight: 500;
            color: #333;
            display: inline-block;
            vertical-align: middle;
          }
        }
        .right-content {
          margin-left: 87px;
          .applicant-names {
            font-size: 14px;
            color: #333;
            word-break: break-all;
            line-height: 26px;
            margin-bottom: 10px;
            font-weight: 400;
          }
          ul {
            list-style: none;
            .material {
              display: flex;
              justify-content: center;
              align-items: center;
              color: #777;
              font-size: 14px;
              line-height: 14px;
              padding: 10px 0;
              &.border-bottom {
                border-bottom: 1px solid #f0f0f0;
              }
              .title {
                flex: 1;
                .required {
                  color: #ff5a60;
                }
              }
              .action {
                width: 191px;
                display: flex;
                justify-content: flex-end;
                .s-btn {
                  width: 70px;
                  height: 20px;
                  font-size: 12px;
                  line-height: 10px;
                  padding: 4px 11px;
                  color: #777;
                  border-color: #777;
                  &.is-plain {
                    color: #5e9be1;
                    border-color: #5e9be1;
                  }
                }
              }
            }
          }
        }
        .bottom-line {
          border-bottom: 1px solid #f0f0f0;
        }
      }
    }
  }
  .footer {
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
    padding: 15px 20px;
    font-size: 14px;
    span {
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/sf-order-mail-list.vue